import { Component, ChangeDetectionStrategy, Output, EventEmitter, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { BusinessTypeUI } from 'src/models';
import { AlertService, BusinessTypesService } from 'src/core/services';
import { TranslateService } from '@ngx-translate/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-business-types',
  templateUrl: './business-types.component.html',
  styleUrls: ['./business-types.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessTypesComponent extends BaseResizableComponent {
  private readonly businessTypesService = inject(BusinessTypesService);
  private readonly translateService = inject(TranslateService);
  private readonly alertService = inject(AlertService);

  @Output() save = new EventEmitter<BusinessTypeUI[]>();

  allBusinessTypes$ = this.businessTypesService.allBusinessTypes$;

  override ngOnInit(): void {
    super.ngOnInit();

    this.businessTypesService.getAllBusinessTypes();
  }

  onSave(visibleBusinessTypes: BusinessTypeUI[]) {
    this.businessTypesService
      .saveBusinessTypes(visibleBusinessTypes)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(() => {
        this.businessTypesService.getAllBusinessTypes();
        this.businessTypesService.getBusinessTypes();
        this.alertService.success(
          this.translateService.instant('components.businessTypes.alerts.successes.saveBusinessTypes'),
        );

        this.save.emit(visibleBusinessTypes);
      });
  }
}
